import * as Sentry from '@sentry/browser';

export default function logMessage(message) {
  if (process.env.REACT_APP_MODE === 'DEVELOPMENT') {
    console.log('Log Message: ', message);
  }

  Sentry.captureMessage(message);
}
